import { fetchData } from './dataApi';
import {
  clearConversationV2Cache,
  loadConversationCategories,
  loadConversationDocument,
} from './conversationV2';

export { loadConversationCategories };

export function conversationToPracticeData(chapter) {
  const speakers = new Map((chapter.speakers || []).map((speaker) => [speaker.id, speaker.displayName]));
  const content = {};
  (chapter.lines || []).forEach((line) => {
    if (line.type !== 'dialogue') return;
    const spoken = (line.segments || [])
      .filter((segment) => segment.type === 'speech' && segment.text)
      .map((segment) => segment.text)
      .join(' ')
      .trim();
    if (!spoken) return;
    const speaker = speakers.get(line.speakerId);
    content[line.id] = speaker ? `${speaker}: ${spoken}` : spoken;
  });
  return { id: chapter.conversationId, label: chapter.title || '', content };
}

export async function loadConversationChapter(locale, conversationId) {
  return conversationToPracticeData(await loadConversationDocument(locale, conversationId));
}

export function grammarLessonToPracticeTense(lesson, document) {
  const section = (document.sections || []).find((item) => item.id === lesson.id)
    || document.sections?.[0];
  if (!section) return null;
  const rows = (section.examples || []).map((example) => ({
    person: example.tokens?.subject || example.id,
    form: example.tokens?.verb || example.tokens?.linkingVerb || example.text,
  })).filter((row) => row.person && row.form);
  return {
    name: section.label || lesson.label || lesson.id.replaceAll('_', ' '),
    use: section.concept || '',
    verb: section.patterns?.[0]?.form || '',
    rows,
    examples: (section.examples || []).map((example) => example.text).filter(Boolean),
  };
}

export async function loadGrammarPractice(locale) {
  let manifest;
  let dataLocale = locale;
  try {
    manifest = await fetchData(`grammar/${locale}/index.json`);
  } catch (localeError) {
    if (locale !== 'en') {
      try {
        await fetchData(`grammar/${locale}/foundations/foundations_1.json`);
        manifest = await fetchData('grammar/en/index.json');
      } catch {
        manifest = await fetchData('grammar/en/index.json');
        dataLocale = 'en';
      }
    } else {
      throw localeError;
    }
  }

  const lessons = (manifest.lessons || []).filter((lesson) => lesson.category === 'tense_aspect');
  const results = await Promise.all(lessons.map(async (lesson) => {
    try {
      const document = await fetchData(`grammar/${dataLocale}/${lesson.file}`);
      return grammarLessonToPracticeTense(lesson, document);
    } catch (error) {
      if (dataLocale === 'en') throw error;
      const source = await fetchData(`grammar/en/${lesson.file}`);
      return grammarLessonToPracticeTense(lesson, source);
    }
  }));
  return results.filter(Boolean);
}

export function clearPracticeV2Cache() {
  clearConversationV2Cache();
}
